<template>
    <v-card>
        <v-card-title>Edit Sector #{{sectorClone.sect_num}}</v-card-title>

        <v-divider />

        <v-card-text>
            <v-form ref="sectorForm" v-model="secotrFormValid" :lazy-validation="true">
                <v-row dense >
                    <v-col cols="12" md="4" class="mt-4">
                        <v-text-field label="Sector Number" color="#c42111" v-model="sectorClone.sect_num" disabled />
                    </v-col>
                    <v-col cols="12" md="4" class="mt-4">
                        <v-text-field label="Cell ID" color="#c42111" v-model="sectorClone.sect_mscid" disabled />
                    </v-col>
                    <v-col cols="12" md="4" class="mt-4">
                        <v-text-field label="Azimuth" type="number" min="0" max="360" color="#c42111" v-model="sectorClone.sect_azimuth" :rules="[$store.state.validationFuncs.required(sectorClone.sect_azimuth, 'Azimuth'), $store.state.validationFuncs.intRange(sectorClone.sect_azimuth, 0, 360, 'Azimuth')]" />
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field label="Name" color="#c42111" v-model="sectorClone.sect_name" />
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-datetime-picker label="On Air Date/Time" v-model="sectorClone.sect_on_air_time" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps" ></v-datetime-picker>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-datetime-picker label="Decomm Date/Time" v-model="sectorClone.sect_decomm_time" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps" ></v-datetime-picker>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field label="Remote Latitude" type="number" min="-90" max="90" color="#c42111" v-model="remotePositionLat" :rules="[$store.state.validationFuncs.allRequiredIfAnyHasValue([{value: remotePositionLat, name: 'Remote Latitude'}, {value: remotePositionLng, name: 'Remote Longitude'}]), $store.state.validationFuncs.floatRange(remotePositionLat, -90, 90, 'Remote Latitude')]" />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field label="Remote Longitude" type="number" min="-180" max="180" color="#c42111" v-model="remotePositionLng" :rules="[$store.state.validationFuncs.allRequiredIfAnyHasValue([{value: remotePositionLat, name: 'Remote Latitude'}, {value: remotePositionLng, name: 'Remote Longitude'}]), $store.state.validationFuncs.floatRange(remotePositionLng, -180, 180, 'Remote Longitude')]" />
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn text @click="cancelClicked">Cancel</v-btn>
          <v-btn text @click="okClicked">Ok</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import Vue from 'vue'
import DatetimePicker from 'vuetify-datetime-picker'
Vue.use(DatetimePicker)
export default {
    name: 'SectorEdit',
    props: ['sector'],
    components: {
        DatetimePicker
    },
    data: () => ({
        sectorClone: null,
        remotePositionLat: null,
        remotePositionLng: null,
        tpProps: {
            useSeconds: true,
            format: '24hr',
            color: '#c42111'
        },
        dpProps: {
            color: '#c42111'
        },
        secotrFormValid: true
    }),

    computed: {

    },

    methods: {
        cancelClicked: function() {
            this.$emit('close');
        },

        okClicked: function() {
            if(this.$refs.sectorForm.validate()) {
                this.$props.sector.sect_num = this.sectorClone.sect_num;
                this.$props.sector.sect_mscid = this.sectorClone.sect_mscid;
                this.$props.sector.sect_azimuth = this.sectorClone.sect_azimuth;
                this.$props.sector.sect_name = this.sectorClone.sect_name;
                this.$props.sector.sect_on_air_time = this.sectorClone.sect_on_air_time ? TELSA.moment(this.sectorClone.sect_on_air_time).format('YYYY-MM-DD HH:mm:ss') : '';
                this.$props.sector.sect_decomm_time = this.sectorClone.sect_decomm_time ? TELSA.moment(this.sectorClone.sect_decomm_time).format('YYYY-MM-DD HH:mm:ss') : '';
                if(!this.$props.sector.sect_data) {
                    // This shouldn't ever really happen but just to be safe.
                    this.$props.sector.sect_data = {};
                }
                this.$props.sector.sect_data.remote_position = {lat: this.remotePositionLat ? parseFloat(this.remotePositionLat) : null, lng: this.remotePositionLng ? parseFloat(this.remotePositionLng) : null};

                // The deep watcher on Sites doesn't detect changes to the sector data object. Do a hash compare to manually trigger isDirty
                if(TELSA.hash(this.sectorClone.sect_data ? this.sectorClone.sect_data : null) != TELSA.hash(this.$props.sector.sect_data)) {
                    if(!this.$props.lockSave) {
                        this.$store.commit('setIsDirty', true);
                    }
                }
                this.$emit('close');
            }
        }
    },

    watch: {
    },

    mounted() {
    },

    created() {
        this.sectorClone = JSON.parse(JSON.stringify(this.$props.sector));
        this.remotePositionLat = (this.sectorClone.sect_data && this.sectorClone.sect_data.remote_position) ? this.sectorClone.sect_data.remote_position.lat : null;
        this.remotePositionLng = (this.sectorClone.sect_data && this.sectorClone.sect_data.remote_position) ? this.sectorClone.sect_data.remote_position.lng : null;
    }

  
};
</script>
